import { FC, useMemo } from "react";
import { AppPartType } from "../../../types";
import { Select } from "antd";

type PropsType = {
  appPart: AppPartType;
};

export const defaultValueOptionDropDown = [
  { label: "サンプル1", value: "サンプル1" },
  { label: "サンプル2", value: "サンプル2" },
];

const DropdownPart: FC<PropsType> = ({
  appPart: {
    default_value,
    item_config_data: { options },
  },
}) => {
  const selectOptions = useMemo(() => {
    if (options && Array.isArray(options) && options?.length > 0) {
      return options?.map((o) => ({ label: o.text, value: o.text }));
    } else {
      return defaultValueOptionDropDown;
    }
  }, [options]);

  const defaultValue = useMemo(() => {
    if (options && Array.isArray(options) && options?.length > 0) {
      return selectOptions.find((o: any) => o.value === default_value);
    } else {
      return defaultValueOptionDropDown[0];
    }
  }, [selectOptions, default_value, options]);

  return (
    <Select
      style={{ width: "100%" }}
      disabled
      value={defaultValue}
      options={selectOptions}
    />
  );
};

export default DropdownPart;
